<template>
	<div style="color: #303133;">
		<el-form :model="form" :rules="rules" ref="form">
			<el-form-item :label="school.displayname+(school.fieldtip?'('+school.fieldtip+')':'')||''" required>
				<el-input v-model="form.school.name" :placeholder="school.placecontent||''" disabled clearable></el-input>
				<yincan :content="school.inputtip"></yincan>
			</el-form-item>

			<el-form-item :label="teamlable.displayname+(teamlable.fieldtip?'('+teamlable.fieldtip+')':'')||''" prop="team_id" required>
				<el-select style="width: 100%;" v-model="form.team_id" @change="handleTeamChange" :placeholder="teamlable.placecontent||'请选择团队'" clearable>
					<el-option v-for="item in myTeamList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<yincan :content="teamlable.inputtip"></yincan>
			</el-form-item>
			
			<el-form-item :label="namelable.displayname+(namelable.fieldtip?'('+namelable.fieldtip+')':'')||''" prop="name">
				<el-input v-model="form.name" :placeholder="namelable.placecontent||''" clearable maxlength="20"></el-input>
				<yincan :content="namelable.inputtip"></yincan>
			</el-form-item>

			<el-form-item :label="declarecontentlable.displayname+(declarecontentlable.fieldtip?'('+declarecontentlable.fieldtip+')':'')||''" prop="isdeclare">
				<el-radio-group v-model="form.isdeclare">
					<el-radio :label="0">常规奖项目</el-radio>
					<el-radio :label="1">品牌奖项目</el-radio>
				</el-radio-group>
			</el-form-item>
			<div v-if="form.isdeclare==1">
				<table>
					<tr scope="col">
						<td>首次参赛时间</td>
						<td colspan="2">
							<el-input v-model="prize.prizetime" placeholder="请输入首次参赛时间" clearable></el-input>
						</td>
					</tr>
					<tr>
						<td>首次参赛名称</td>
						<td colspan="2">
							<el-input v-model="prize.prizename" placeholder="请输入首次参赛名称" clearable></el-input>
						</td>
					</tr>
					<tr>
						<td rowspan="3">历年成果</td>
						<td>
							<el-input v-model="prize.prizeyear1" placeholder="请输入年份" clearable>
								<template slot="append">年</template>
							</el-input>
						</td>
						<td>
							<el-input v-model="prize.achievement1" placeholder="请输入奖项名称" clearable></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<el-input v-model="prize.prizeyear2" placeholder="请输入年份" clearable>
								<template slot="append">年</template>
							</el-input>
						</td>
						<td>
							<el-input v-model="prize.achievement2" placeholder="请输入奖项名称" clearable></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<el-input v-model="prize.prizeyear3" placeholder="请输入年份" clearable>
								<template slot="append">年</template>
							</el-input>
						</td>
						<td>
							<el-input v-model="prize.achievement3" placeholder="请输入奖项名称" clearable></el-input>
						</td>
					</tr>
					<tr>
						<td>{{ points.displayname+(points.fieldtip?'('+points.fieldtip+')':'')||'' }}</td>
						<td colspan="2">
							<el-input type="textarea" v-model="prize.prizes" :placeholder="points.placecontent" :maxlength="points.len" clearable></el-input>
						</td>
					</tr>
				</table>
			</div>
			<yincan :content="declarecontentlable.inputtip" />

			<el-form-item :label="projectneirong.displayname+(projectneirong.fieldtip?'('+projectneirong.fieldtip+')':'')||''" prop="project_type_ids">
				<el-select class="select" :multiple="multiple" v-model="form.project_type_ids" :placeholder="projectneirong.placecontent||''" clearable>
					<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<yincan :content="projectneirong.inputtip"></yincan>
			</el-form-item>

			<div class="teamMember-head">
				<div>{{ teachertable.displayname+(teachertable.fieldtip?'('+teachertable.fieldtip+')':'')||'' }}</div>
				<!-- <el-link class="teamMemberAddLink" type="success" @click="addTeam">添加</el-link> -->
			</div>
			<el-form :model="team" :rules="teamRules" ref="team" v-for="(item,index) in team.teachers" :key="index">
				<el-form-item label="指导教师" :prop="'teachers.'+index+'.name'" :rules="teamRules.name">
					<el-input v-model="item.name" placeholder="请输入指导教师" clearable></el-input>
				</el-form-item>
				<el-form-item label="指导教师联系方式" :prop="'teachers.'+index+'.phone'" :rules="teamRules.phone">
					<el-input v-model="item.phone" placeholder="请输入指导教师联系方式" clearable></el-input>
				</el-form-item>
				<el-form-item label="指导教师职务" :prop="'teachers.'+index+'.position'">
					<el-input v-model="item.position" placeholder="请输入指导教师职务" clearable></el-input>
				</el-form-item>
				<el-form-item label="教师专业" :prop="'teachers.'+index+'.teachermajor'">
					<el-input v-model="item.teachermajor" placeholder="请输入指导教师专业" clearable></el-input>
				</el-form-item>
				<el-link type="danger" @click="deleteTeam(item,index)" v-if="index==1">删除</el-link>
			</el-form>
			<yincan :content="teachertable.inputtip"></yincan>
			<!-- <div class="fz-FF0000">最多两名</div> -->
			<div class="cntert">
				<el-button class="buttonWidth" type="success" size="medium" @click="toStep2">下一步</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
	import {
		saveProject,
		getProjectTypeAll,
		getProjectType,
		getProjectTeacher,
		delProjectTeacher,
		saveProjectTeacher,
		getMyCreateTeam
	} from "../../../api/signUp";
	import {
		validPhone
	} from "../../../validate/common";
	import res from "../../../utils/msg";
	import yincan from "../../../components/yincan.vue";
	import {
		mapGetters,
	} from 'vuex';
	export default {
		components: {
			yincan
		},
		data() {
			return {
				draftData: {}, // 草稿箱数据
				typeList: [], // 项目内容
				form: {
					iscg: 1,
					project_id: "", // 项目 id
					school: "", // 学校名称
					team: "", // 团队
					team_id: "", // 团队 id
					name: "", // 项目名称
					project_type_id: "", // 项目类型
					teacher: "", // 指导老师
					teacherphone: "", // 老师联系方式
					dutyperson: "", // 项目负责人
					dutypersonphone: "", // 项目负责人联系方式
					address: "", // 通讯地址
					introduce: "", // 项目简介
					innovate: "", // 项目创新点
					activitytime: "", // 活动时间
					activityaddress: "", // 活动地点
					activityobject: "", // 活动对象
					step: "", // 步骤
					risk: "", // 项目风险
					target: "", // 预期目标
					isdeclare: 0, //奖项
					declarecontent: '',
				},
				prize: {
					prizetime: '',
					prizename: '',
					prizeyear1: '',
					achievement1: '',
					prizeyear2: '',
					achievement2: '',
					prizeyear3: '',
					achievement3: '',
					prizes: ''
				},
				team:{
					teachers: [{
						name: '',
						phone: '',
						position: '',
						teachermajor: ''
					}],
				},
				myTeamList: [],//我的团队
				ateachers: [{
					name: '',
					phone: '',
					position: '',
					teachermajor: ''
				}],
				typechoose: '',
				multiple: '',
				rules: {
					team_id: [{
						required: true,
						message: '请选择团队',
						trigger: "change"
					}],
					name: [{
						required: true,
						message: ' ',
						trigger: "blur"
					}],
					project_type_ids: [{
							required: true,
							message: ' ',
							trigger: "blur"
					}]},
				teamRules: {
				  name: [
				    { required: true, message: " ", trigger: "blur" },
				  ],
				  phone: [
				    {
				      message: "请输入正确的联系方式",
				      trigger: "blur",
				    //   validator: validPhone,
				    },
				  ],
				},
				school:{
					displayname:'',
					placecontent:'',
					len:''
				},//学校
				teamlable:{
					displayname:'',
					placecontent:'',
					len:''
				},//团队
				namelable:{
					displayname:'',
					placecontent:'',
					len:''
				},//项目名称
				declarecontentlable:{
					displayname:'',
					placecontent:'',
					len:''
				},//奖项
				projectneirong:{
					displayname:'',
					placecontent:'',
					len:''
				},//项目内容
				teachertable:{
					displayname:'',
					placecontent:'',
					len:''
				},//老师
				points:{
					displayname:'',
					placecontent:'',
					len:''
				},//创新点
			};
		},
		mounted() {
			this.getMyTeam()
			setTimeout(() => {
				this.getLable()
			}, 1500);
		},
		methods: {
			// 切换团队时，同步修改学校名称
			handleTeamChange(val) {
				if (val) {
					const selectedTeam = this.myTeamList.find(item => item.id === val);
					if (selectedTeam && selectedTeam.schoolname) {
						if (!this.form.school) {
							this.$set(this.form, 'school', { name: selectedTeam.schoolname });
						} else {
							this.$set(this.form.school, 'name', selectedTeam.schoolname);
						}
					}
				} else {
					if (this.form.school) {
						this.$set(this.form.school, 'name', '');
					}
				}
			},
			//获得我的创建的团队
			getMyTeam(){
				const userInfo = localStorage.getItem('userInfo')
				getMyCreateTeam({
						user_id: JSON.parse(userInfo).id,
				}).then(res => {
					this.myTeamList = res.data.data.filter(item => item.status == 2)
				})
			},
			getLable(){
				this.school = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'school')
				this.teamlable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'team')
				this.namelable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'name')
				this.declarecontentlable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'declarecontent')
				this.projectneirong = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'projectneirong')
				this.teachertable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'teachertable')
				this.points = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'points')
			},
			gettype() {
				getProjectType().then(res => {
					this.typechoose = res.data.value
					if (res.data.value == 1) {
						this.multiple = true
						this.form.project_type_ids = this.form.project_type_ids
							.split(",")
							.map(Number);
					} else {
						this.multiple = false
						if(!this.form.project_type_ids){
							this.form.project_type_ids=""
						}else{
							this.form.project_type_ids = Number(this.form.project_type_ids)
						}
					}
				})
			},
			async getProjectTeacher() {
				let _data = {
					project_id: this.form.project_id||this.form.id,
				};
				try {
					let findRes = await getProjectTeacher(_data);
					if (findRes.data.code == 1) {
						if (findRes.data.data == [] || !findRes.data.data || findRes.data.data.length == 0) {
							this.team.teachers = this.ateachers
						} else {
							this.team.teachers = findRes.data.data;
						}
					}
				} catch (error) {
					console.log(error);
				}
			},
			//删除老师
			async deleteTeam(item, index) {
				if (item.id) {
					let _data = {
						id: item.id,
					};
					try {
						let deleteRes = await delProjectTeacher(_data);
						if (deleteRes.data.code === 1) {
							this.$message.success(deleteRes.data.msg);
							await this.getProjectTeacher();
						} else {
							this.$message.error(deleteRes.data.msg);
							await this.getProjectTeacher();
						}
					} catch (error) {
						console.log(error);
					}
				} else {
					this.team.teachers.forEach((v1, i1) => {
						if (i1 == index) {
							this.team.teachers.splice(i1, 1);
						}
					});
				}
			},
			//保存老师
			savememberfn() {
				if (this.team.teachers.length > 0) {
						let flag = this.team.teachers.every(v => {
							return v.name && v.phone && v.teachermajor && v.position
						});
						if (!flag) {
							this.$message.error('请补全教师信息');
							return
						};
						for (var i = 0; i < this.team.teachers.length; i++) {
							this.team.teachers[i].project_id = this.form.project_id||this.form.id;
							console.log(this.team.teachers[i]);
							saveProjectTeacher(this.team.teachers[i]).then(reseon => {
								if (reseon.data.code == 1) {
									this.getProjectTeacher()
								} else {
									// this.$message.error(reseon.msg)
								}
							})
						}
					} else {
						
					}
			},
			// addTeam() {
			// 	if (this.team.teachers.length >= 2) {
			// 		res.error("指导老师最多为2个");
			// 		return
			// 	}
			// 	this.team.teachers.push({
			// 		name: '',
			// 		phone: '',
			// 		position: '',
			// 		teachermajor: ''
			// 	});
			// },
			getFather_step1(data) {
				this.form = data;
				this.getProjectTeacher()
				this.gettype()
				this.getProjectTypeAllData();
				if(this.form.declarecontent_data){
					this.prize = this.form.declarecontent_data
				}
				if(!this.form.isdeclare){
					this.form.isdeclare = 0
				}
				// if (this.form.project_type_ids === null) {
				// 	this.form.project_type_ids = [];
				// } else {
				// 	if (this.typechoose == 1) {
				// 		this.form.project_type_ids = this.form.project_type_ids
				// 			.split(",")
				// 			.map(Number);
				// 	} else {
				// 		this.form.project_type_ids = Number(this.form.project_type_ids)

				// 	}
				// }
			},
			async toStep2() {
				await this.savememberfn();
				this.form.declarecontent = JSON.stringify(this.prize)
				const _this = this;
				
				// 如果是品牌奖项目，需要验证品牌奖表单
				if (this.form.isdeclare == 1) {
					const prizeValid = this.validatePrizeForm();
					if (!prizeValid) {
						return;
					}
				}
				
				_this.validateMainForm();
			},
			validatePrizeForm() {
				const errors = [];
				
				// 验证首次参赛时间
				if (!this.prize.prizetime.trim()) {
					errors.push('请输入首次参赛时间');
				}
				
				// 验证首次参赛名称
				if (!this.prize.prizename.trim()) {
					errors.push('请输入首次参赛名称');
				}
				
				// 验证本届创新点
				if (!this.prize.prizes.trim()) {
					errors.push('请输入本届创新点');
				}
				
				// 验证历年成果至少填一项
				const hasAchievement = 
					(this.prize.prizeyear1 && this.prize.achievement1) ||
					(this.prize.prizeyear2 && this.prize.achievement2) ||
					(this.prize.prizeyear3 && this.prize.achievement3);
				
				if (!hasAchievement) {
					errors.push('历年成果至少需要填写一项');
				}
				
				// 如果有错误，显示弹窗
				if (errors.length > 0) {
					this.$alert(errors.join('<br/>'), '验证失败', {
						dangerouslyUseHTMLString: true,
						type: 'warning'
					});
					return false;
				}
				
				return true;
			},
			validateMainForm() {
				const _this = this;
				_this.$refs.form.validate(async (valid) => {
					if (valid) {
						let _data = {
							...this.form,
							...this.team.teachers,
							project_id:this.form.project_id||this.form.id,
						};
						// 把 project_type_id 转为逗号分隔的字符串
						if (this.typechoose == 1) {
							let newProjectTypeStrs = "";
							for (const v of _data.project_type_ids) {
								newProjectTypeStrs += v + ",";
							}
							newProjectTypeStrs = newProjectTypeStrs.substring(
								0,
								newProjectTypeStrs.length - 1
							);
							_data.project_type_ids = newProjectTypeStrs;
						}
						try {
							let saveRes = await saveProject(_data);
							console.log(saveRes, "saveRes");
							if (saveRes.data.code == 1) {
								this.$message.success('更新成功');
								_this.$parent.doNext();
							} else {
								this.$message.error(saveRes.data.msg);
							}
						} catch (error) {
							console.log(error);
						}
					}
				});
			},
			// 项目内容下拉列表
			async getProjectTypeAllData() {
				let res = await getProjectTypeAll();
				if (res.data.code == 1) {
					if (Array.isArray(res.data.data)) {
						this.typeList = res.data.data.map(v => ({
							value: v?.id,
							label: v?.name,
						}));
					} else {
						console.log('res.data 不是一个数组', res.data);
					}
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.teamMember-head {
		line-height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #606266;
	}

	.select {
		width: 100%;
	}

	.fz-FF0000 {
		color: #FF0000;
		font-size: 14px;
	}

	.fz-999999 {
		color: #999;
	}

	table {

		// border: #333 1px solid;
		tr {
			border: #333 1px solid;
		}

		td {
			border: #333 1px solid;
		}
	}
</style>